





















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'cIconArrowRight',
  setup(props, context) {
    const onClickEvent = (event: MouseEvent): void => {
      context.emit('onArrowClick', event);
    };

    return {
      onClickEvent,
    };
  },
});
